<fieldset class="radio-group-input">
  <div *ngFor="let option of options" class="button-group">
    <input
      type="radio"
      [id]="option.name"
      name="frameworks"
      [value]="option.value"
      [checked]="selectedOption?.value === option.value"
      (change)="onOptionSelected(option)"
    />
    <label [class.has-error]="hasError" [for]="option.name">{{ option.name }}</label>
  </div>
</fieldset>
